interface card {
  title: string
  slug: string
  categories: [
    {
      title: string
    }
  ]
}

interface term {
  title: string
}

export const useFilters = (activeCategories: term[], cards: card[]) => {
  if (!Array.isArray(activeCategories) || activeCategories.length === 0) {
    return cards
  }

  //loop all cards
  return cards.filter((card) => {
    // loop all active Filters
    return activeCategories.some((filterTerm) => {
      // loop all terms of event
      return card.categories.some((category) => {
        return filterTerm === category.title
      })
    })
  })
}
